import { BASE_SCHEMA } from '@/shared/converters/baseConverters';
import { parseEntities, parseEntity } from '@/shared/converters/commonConverters';
import AbsenceType from '../models/AbsenceType';

const SCHEMA = {
  ...BASE_SCHEMA,
  description: 'description',
  isActive: 'isActive',
};

export function parseAbsenceTypes(data: any): Array<AbsenceType> {
  return parseEntities(data, SCHEMA, AbsenceType);
}

export function parseAbsenceType(data: any): AbsenceType | null {
  return parseEntity(data, SCHEMA, AbsenceType);
}